<script setup>
    import { reactive, ref } from "vue";

const props = defineProps({
    params : {}
});

    const imgIcon = ref('');

    switch (props.params.value) {
        case 'pdf':
            imgIcon.value = 'file-pdf';
            break;

        case 'jpg':; case 'jpeg':; case 'png':; case 'gif':
            imgIcon.value = 'file-image';
            break;

        case 'doc':; case 'docx':
            imgIcon.value = 'file-word';
            break;

        case 'ppt':; case 'pptx':
            imgIcon.value = 'file-powerpoint';
            break;

        case 'xls':; case 'xlsx':
            imgIcon.value = 'file-excel';
            break;

        case 'mp4':; case 'mkv':; case 'avi':; case 'mov':; case 'wmv':;
        case 'mpeg':; case 'mpg':; case 'm4v':; case 'flv':
            imgIcon.value = 'file-video';
            break;

        case 'zip':; case 'rar':
            imgIcon.value = 'file-archive';
            break;

        case '/dir':
            imgIcon.value = 'folder';
            break;

        default:
            imgIcon.value = 'file-alt'
            break;
}
</script>

<template>
    <span style="margin-left: 10px;">
        <font-awesome-icon class="filetype-icon" :icon="imgIcon" size="2x" />
    </span>
</template>

<style>
    .filetype-icon {
        color: #850f5f;
    }
</style>